/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function CandidatesAndOfficialAgentsInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Candidates and Official Agents"
              description={
                <>
                  <h3>How to Become a Candidate?</h3>
                  <br/>
                  <p>There are two types of candidates in Nova Scotia: those who are affiliated with a registered political party, and independents. If you are planning to run for election as an MLA representing a party, the party must first register with the Chief Electoral Officer.</p>
                  <br/>
                  <p>Determine if you are eligible</p>
                  <br />
                    <ul style={{ paddingLeft: "40px" }}>
                    <li>be an eligible elector, i.e.,&nbsp;be at least 18 years of age on election day,&nbsp;be a Canadian citizen, and a resident of Nova Scotia for six months preceeding the issuance of the writ, and</li>
                    <li>not be disqualified to be a candidate or MLA under the <a href="https://nslegislature.ca/sites/default/files/legc/statutes/elections.pdf">Elections Act</a>, <a href="https://nslegislature.ca/sites/default/files/legc/statutes/house%20of%20assembly.pdf">House of Assembly Act</a>, or any other Provincial Act</li>
                  </ul>
                  <br/>


                  <h3>The Candidate Nomination Process</h3>
                  <br/>
                  <p>Regardless of whether an individual has been nominated by a registered party or intends to run as an independent candidate, and regardless of their registration status with ENS, they must be officially nominated at their returning office after the call of an election to be eligible to run for a seat in the House of Assembly. This nomination must be completed in accordance with the requirements of the Elections Act.</p>
                  <br/>
                  <p>You must file your completed nomination forms (<a href="/files/Forms&Handbooks/Candidates/105_Candidate Nomination_2026.pdf">Form 105, Candidate Nomination </a>) with the Returning Officer in the electoral district in which you wish to run not later than <b>2:00 pm on the 20th day before election day.</b></p>
                  <br/>


                  <h3>Candidate Registration</h3>
                  <br/>
                  <p>Candidates must register with Elections Nova Scotia before their Official Agent receives a contribution or transfer, or incurs an expense.&nbsp;
                    <a href="/files/CandidatesAndOfficialAgents/1-1_Application for Candidate Registration_PDF Fillable.pdf" target="_blank"> Form 1-1 </a>
                    must be completed and submitted for approval by the Chief Electoral Officer. &nbsp;If the candidate is endorsed by a registered political party, the registration form must also provide a statement of endorsement signed by the leader of that registered party. A Candidate may register at any time prior to a writ of election is issued.&nbsp;</p>
                  <br/>

                  
                  <h3>Current Registered Candidates</h3>
                  <br/>
                  <p>The following candidate(s) are registered for pending elections in the electoral district indicated.<br />
                    <ul style={{ paddingLeft: "40px" }}>
                      <li>Peter MacIsaac, Independent Candidate – Inverness</li>
                      <li>Elizabeth Smith-McCrossin, Independent Candidate – Cumberland North</li>
                      <li>Lorne Fraser, Independent Candidate – Kings North</li>
                      <li>Julissa Stewart, Independent Candidate – Richmond</li>
                    </ul></p>
                    <br/>


                  <h3>Please review the following for more information.</h3>
                  <ul style={{ paddingLeft: "40px" }}>
                      <li>Guide for Candidate Nomination: <a href="files/Forms&Handbooks/Candidates/F107 - Guide for Candidate Nomination.pdf">Link</a></li>
                      <li>Information for Prospective Candidates: <a href="files/CandidatesAndOfficialAgents/F159-Information for Prospective Candidate.pdf">Link</a></li>
                      <li>Candidates Frequently Asked Questions (FAQs): <a href="files/CandidatesAndOfficialAgents/Candidate FAQs.pdf">Link</a></li>
                  </ul>
                  
            </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default CandidatesAndOfficialAgentsInformation;
